import UpgradeNotification from './UpgradeNotification';

export default UpgradeNotification;
